// Constants and helpers shared by the CTO Candidates table and its edit drawer.

export const TITLE_OPTIONS = [
  'Staff Engineer',
  'Principal Engineer',
  'Senior Backend Engineer',
  'Lead Engineer',
  'Platform Engineer',
];

export const CONTACT_METHOD_OPTIONS = [
  'LinkedIn',
  'Email',
  'Warm Intro',
  'Other',
];

export const SCORE_TOOLTIP =
  '5 = Strong (8–15+ yrs, backend, systems, leadership)\n' +
  '4 = Good (7+ yrs, backend)\n' +
  '3 = Maybe (5–7 yrs, mixed)\n' +
  '2 = Weak\n' +
  '1 = No';

export const SCORE_GUIDE =
  '5 = Strong Target (message immediately) · 4 = Good Candidate (message) · 3 = Maybe (use sparingly) · 2 = Weak (skip) · 1 = No (skip)';

export const getScoreColor = (score) => {
  if (score >= 5) return '#22c55e';
  if (score === 4) return '#84cc16';
  if (score === 3) return '#facc15';
  if (score === 2) return '#f97316';
  return '#ef4444';
};

export const getAction = (score) => {
  if (!score) return null;
  if (score >= 5) return 'Message immediately';
  if (score === 4) return 'Message';
  if (score === 3) return 'Optional';
  return 'Skip';
};

export const ACTION_COLORS = {
  'Message immediately': '#22c55e',
  'Message':             '#84cc16',
  'Optional':            '#facc15',
  'Skip':                '#ef4444',
};

export const getSuggestedScore = (c) => {
  if (c.years_experience >= 7 && c.backend_focus && c.system_architecture) return 5;
  return null;
};
